__turbopack_context__.v({
  "filled": "styles-module-scss-module__ndky5W__filled",
  "indicator": "styles-module-scss-module__ndky5W__indicator",
  "indicatorsContainer": "styles-module-scss-module__ndky5W__indicatorsContainer",
  "mobileCarousel": "styles-module-scss-module__ndky5W__mobileCarousel",
  "slideContent": "styles-module-scss-module__ndky5W__slideContent",
});
